module.exports = __webpack_public_path__ + "static/scale-model-of-walt-disney's-birthplace-in-chicago-illinois-6217ab9d267a41f89c270187b122f6ee.png";